// 재연결 설정 (프로젝트 전역)
export const RECONNECTION_CONFIG = {
  // 자동/수동 재접속 임계값 (밀리초)
  RECONNECT_THRESHOLD: 10000, // 10초

  // 다이얼로그 자동 취소 시간 (밀리초)
  DIALOG_AUTO_CANCEL_TIMEOUT: 30000, // 30초

  // Socket.IO 클라이언트 설정
  RECONNECTION_DELAY: 1000, // 재연결 시도 간격 (1초)
  RECONNECTION_DELAY_MAX: 5000, // 최대 재연결 간격 (5초)
  RECONNECTION_ATTEMPTS: Infinity, // 최대 재연결 시도 횟수 (무제한)

  // 게임 상태 동기화 타임아웃
  SYNC_TIMEOUT: 5000, // 5초
} as const;

// 게임별 임계값 커스터마이징 (선택사항)
export const GAME_SPECIFIC_CONFIG = {
  // 빠른 템포의 게임 (더 빠른 재접속)
  dealerjack: {
    RECONNECT_THRESHOLD: 8000, // 8초
  },
  quiz: {
    RECONNECT_THRESHOLD: 8000, // 8초
  },
  // 느린 템포의 게임 (더 관대한 재접속)
  wtb: {
    RECONNECT_THRESHOLD: 15000, // 15초
  },
  roledistributor: {
    RECONNECT_THRESHOLD: 15000, // 15초
  },
} as const;

// 게임별 설정 가져오기 헬퍼 함수
export function getReconnectThreshold(gameId?: number): number {
  if (!gameId) return RECONNECTION_CONFIG.RECONNECT_THRESHOLD;

  // 게임 ID에 따른 매핑
  const gameMapping: Record<number, keyof typeof GAME_SPECIFIC_CONFIG> = {
    6: "dealerjack",
    7: "quiz",
    1: "wtb",
    2: "roledistributor",
  };

  const gameName = gameMapping[gameId];
  if (gameName && GAME_SPECIFIC_CONFIG[gameName]) {
    return GAME_SPECIFIC_CONFIG[gameName].RECONNECT_THRESHOLD;
  }

  return RECONNECTION_CONFIG.RECONNECT_THRESHOLD;
}
